import { render, staticRenderFns } from "./GoogleDriveUI.vue?vue&type=template&id=10a7123a&"
import script from "./GoogleDriveUI.vue?vue&type=script&lang=js&"
export * from "./GoogleDriveUI.vue?vue&type=script&lang=js&"
import style0 from "./GoogleDriveUI.vue?vue&type=style&index=0&id=10a7123a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports